import { Popover } from '@mui/material'
import { Upload } from 'lucide-react'

export const CreateList = ({ idx, anchorEl, open, handleClose, createFrom }) => {

    return (
        <Popover
            className='p-popover-share'
            id={idx}
            open={open}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
        >
            <div className='options'>
                <button onClick={() => createFrom('cero')}>
                    <i className="bi bi-file-earmark-plus"></i>
                    <span>Crear desde cero</span>
                </button>
                <button onClick={() => createFrom('template')}>
                    <i className="bi bi-star"></i>
                    <span>Desde plantilla</span>
                </button>
                <button onClick={() => createFrom('excel')}>
                    <Upload size={16} className="text-[--primary-color]" />
                    <span className="ms-1">Desde Excel</span>
                </button>
            </div>
        </Popover >
    )
}